import {
  FileCode2,
  FileJson,
  FileSpreadsheet,
  FileText,
} from 'lucide-react';

export const getActionMeta = (action) => {
  const normalized = String(action ?? '').trim().toLowerCase();

  if (normalized.includes('delete') || normalized.includes('remove')) {
    return {
      tone: 'delete',
      label: 'Delete',
      className: 'border-rose-500/25 bg-rose-500/12 text-rose-700 dark:text-rose-200',
    };
  }

  if (normalized.includes('add') || normalized.includes('create')) {
    return {
      tone: 'add',
      label: 'Add',
      className:
        'border-emerald-500/25 bg-emerald-500/12 text-emerald-700 dark:text-emerald-200',
    };
  }

  return {
    tone: 'modify',
    label: 'Modify',
    className: 'border-sky-500/25 bg-sky-500/12 text-sky-700 dark:text-sky-200',
  };
};

export const normalizePath = (value) => String(value ?? '').replace(/\\/g, '/').trim();

export const getPathParts = (filePath) => {
  const normalizedPath = normalizePath(filePath);

  if (!normalizedPath) {
    return {
      directory: 'Unknown location',
      fileName: '--',
      extension: '',
    };
  }

  const segments = normalizedPath.split('/').filter(Boolean);
  const fileName = segments[segments.length - 1] || normalizedPath;
  const extension = fileName.includes('.')
    ? fileName.split('.').pop().toLowerCase()
    : '';

  return {
    directory: segments.length > 1 ? segments.slice(0, -1).join('/') : 'Repository root',
    fileName,
    extension,
  };
};

export const getFileMeta = (filePath) => {
  const { extension } = getPathParts(filePath);

  if (['csv', 'tsv'].includes(extension)) {
    return {
      icon: FileSpreadsheet,
      iconClassName:
        'bg-emerald-500/12 text-emerald-700 ring-1 ring-emerald-500/20 dark:text-emerald-200',
      extensionLabel: extension.toUpperCase(),
    };
  }

  if (['js', 'jsx', 'ts', 'tsx', 'py', 'sh', 'ps1', 'mcmd'].includes(extension)) {
    return {
      icon: FileCode2,
      iconClassName:
        'bg-sky-500/12 text-sky-700 ring-1 ring-sky-500/20 dark:text-sky-200',
      extensionLabel: extension.toUpperCase() || 'SCRIPT',
    };
  }

  if (
    ['json', 'yaml', 'yml', 'xml', 'cfg', 'conf', 'ini', 'properties'].includes(
      extension
    )
  ) {
    return {
      icon: FileJson,
      iconClassName:
        'bg-amber-500/12 text-amber-700 ring-1 ring-amber-500/20 dark:text-amber-200',
      extensionLabel: extension.toUpperCase() || 'CONFIG',
    };
  }

  return {
    icon: FileText,
    iconClassName:
      'bg-muted/50 text-muted-foreground ring-1 ring-border/50 dark:bg-background/40',
    extensionLabel: extension.toUpperCase() || 'FILE',
  };
};

export const toTimestamp = (value) => {
  const date = new Date(value ?? '');
  return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};

export const summarizeItems = (items) => {
  const values = Array.from(items).filter(Boolean);

  if (values.length === 0) {
    return '--';
  }

  if (values.length <= 2) {
    return values.join(' | ');
  }

  return `${values.slice(0, 2).join(' | ')} +${values.length - 2}`;
};
